module.exports = __webpack_public_path__ + "static/15-83c619b1b49dca83637c87e19c96c659.jpg";